import React from 'react';
import { styled } from "styled-components";
import badgeIcon from "~/assets/badge-icon.png";

const Cont = styled.div`
    background: #854DFF;
    color: #FFF;
    padding: 10px 16px 10px 16px;
    padding-left: 60px;
    border-radius: 16px;
    
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
    position: fixed;
    width: 350px;
    z-index: 1000;
    left: 45%;
    top: 25px;
    
    &::before {
      content: '';
      display: block;
      width: 32px;
      height: 32px;
      background-image: url(${badgeIcon});
      background-size: cover;
      position: absolute;
      top: 50%;
      left: 16px;
      transform: translateY(-50%);
    }
`;

const Alert = ({text}) => {
  return (
    <Cont>
      {text}
    </Cont>
  );
};

export default Alert;
